import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SELECTED_COLORS, CAMERA_SELECTED_COLORS } from 'helpers/globals'
import splitAt from 'ramda/src/splitAt'

const [FIRST_COLORS, SECOND_COLORS] = splitAt(Math.ceil(SELECTED_COLORS.length / 2), SELECTED_COLORS)

const fillPicker = ({ fillColor, setHexValue, classes }) =>
  <div className={classes.colorPicker}>
    <div className={classes.row}>
      {
        FIRST_COLORS.map((color) =>
          <div
            onClick={_ => setHexValue(color, 'fillColor')}
            className={classes.color}
            style={{ background: color }}
            key={'fill' + color}
          >
            { fillColor === color &&
              <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
            }
          </div>
        )
      }
    </div>
    <div className={classes.row}>
      {
        SECOND_COLORS.map((color) =>
          <div
            onClick={_ => setHexValue(color, 'fillColor')}
            className={classes.color}
            style={{ background: color }}
            key={'fill' + color}
          >
            { fillColor === color &&
              <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
            }
          </div>
        )
      }
      <div onClick={_ => setHexValue('#0000', 'fillColor')} className={classes.color} style={{ border: 'none' }}>
        <FontAwesomeIcon icon='ban' className={classes.noColorIcon} />
      </div>
    </div>
    <div className={classes.bottomRow}>
      <span>Fill Color</span>
      <input type='text' value={fillColor} onChange={({ target: { value } }) => setHexValue(value, 'fillColor', false)} />
    </div>
  </div>

const borderPicker = ({ strokeColor, setHexValue, labelText, cameraOnly, classes }) =>
  <div className={classes.colorPicker}>
    <div className={classes.row}>
      {
        (cameraOnly ? Object.values(CAMERA_SELECTED_COLORS) : FIRST_COLORS).map((color, i) =>
          <div
            onClick={_ => setHexValue(color, 'strokeColor')}
            className={classes.color}
            style={{ background: color }}
            key={'border' + color}
          >
            { strokeColor === color &&
              <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
            }
          </div>
        )
      }
    </div>
    { !cameraOnly &&
      <div className={classes.row}>
        {
          SECOND_COLORS.map((color, i) =>
            <div
              onClick={_ => setHexValue(color, 'strokeColor')}
              className={classes.color}
              style={{ background: color }}
              key={'border' + color}
            >
              { strokeColor === color &&
                <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
              }
            </div>
          )
        }
        <div className={classes.filler} />
      </div>
    }
    { !cameraOnly &&
      <div className={classes.bottomRow}>
        <span>{ labelText || 'Border Color' }</span>
        <input type='text' value={strokeColor} onChange={({ target: { value } }) => setHexValue(value, 'strokeColor', false)} />
      </div>
    }
  </div>

export const FillPicker = (injectSheet(style)(fillPicker))
export const BorderPicker = (injectSheet(style)(borderPicker))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ColorPicker/index.js